// 禁言彈窗
import dayjs from 'dayjs';

const MutedModal = ({ showMutedModal, setShowMutedModal, t, dispatch }) => {
    const { muted, type = '' } = showMutedModal;

    return (
        <div className="modal">
            <div className="w-[266px] rounded-[12px] py-[20px] px-[8px] text-center bg-white space-y-[22px]">
                <p className="text-h5 text-black pb-[22px] border-b-1 border-dashed border-black2">
                    {t(type === 'comment' ? 'FAILED' : 'BAN')}
                </p>

                <p className="text-bd4n text-black5">
                    {t('FORBID')}
                    <br />
                    {muted && dayjs.unix(muted).format('YYYY/MM/DD HH:mm')}
                </p>

                <button
                    className="text-btn1 text-white trans rounded-[40px] px-[22px] py-[10px] bg-vPurple hover:bg-purple"
                    onClick={() => dispatch(setShowMutedModal(false))}
                >
                    {t('CLOSE')}
                </button>
            </div>

            <div className="close-bg" onClick={() => dispatch(setShowMutedModal(false))} />
        </div>
    );
};

export default MutedModal;
